<div class="loader-wrapper">
    <div class="loader" *ngIf="loading"></div>
</div>

